import { SpinLoading } from 'antd-mobile';
import React from 'react';
import { Root, createRoot } from 'react-dom/client';

let div: HTMLDivElement | null;
let root: Root | null;

export const Loading = {
  show: () => {
    if (!div) {
      // 创建一个新的 div 并附加到 body 上
      div = document.createElement('div');
      div.id = '__loading';
      document.body.appendChild(div);

      // 创建 Root 实例
      root = createRoot(div);
    }
    console.log('show');
    root?.render(
      <div className='fixed top-0 right-0 bottom-0 left-0 bg-black bg-opacity-50 z-[1000] flex justify-center items-center'>
        <SpinLoading color='primary' />
      </div>
    );
  },
  hide: () => {
    if (root) {
      // 卸载 Loading 组件
      root.unmount();
    }
    // 移除 DOM 元素
    const loadingDiv = document.getElementById('__loading');
    if (loadingDiv) {
      document.body.removeChild(loadingDiv);
    }
    div = null;
    root = null;
  },
};
